export default "__VITE_ASSET__Dxrj6uM1__"